import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { useCallback } from "react";
import { useToggle } from "usehooks-ts";
import Icon from "../../../base/icons/icon/index.js";
import * as S from "./styled.js";
export const Accordion = ({ header , content , className ='' , iconOpen ='angle-down' , iconClose ='angle-up'  })=>{
    const [isHide, toggleVisibility] = useToggle(true);
    const handleOnClick = useCallback(()=>{
        toggleVisibility();
    }, [
        toggleVisibility
    ]);
    return /*#__PURE__*/ _jsxs(S.AccordionContainer, {
        "data-testid": "Accordion",
        className: className,
        children: [
            /*#__PURE__*/ _jsxs(S.AccordionHeader, {
                onClick: handleOnClick,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "header",
                        children: header
                    }),
                    content && /*#__PURE__*/ _jsx(Icon, {
                        className: `nico-${isHide ? iconOpen : iconClose}`
                    })
                ]
            }),
            content && /*#__PURE__*/ _jsx(S.AccordionContent, {
                className: classNames({
                    'is-hide': isHide
                }),
                children: content
            })
        ]
    });
};
export default Accordion;

//# sourceMappingURL=index.js.map